import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = ({ children, immersive = false, hideFooter = false }) => {
  return (
    <div
      className={
        immersive
          ? "h-screen flex flex-col overflow-hidden"
          : "min-h-screen flex flex-col"
      }
    >
      <Header />

      <main className={immersive ? "flex-1 min-h-0" : "flex-1"}>
        {children || <Outlet />}
      </main>

      {!immersive && !hideFooter && <Footer />}
    </div>
  );
};

export default MainLayout;
